import React, { Component, Fragment } from 'react';
import { capitalize } from 'lodash';
import moment from 'moment';
import DatePicker from 'react-datepicker';

import { HOURS } from '../../pages/constants';

import Label from './Label';

class DateTimePicker extends Component {
  handleDate = (date) => {
    const newDateTime = moment(date).hour(this.time()).minutes(0);
    this.props.onChange(newDateTime);
  };

  handleTime = (event) => {
    const newDateTime = moment(this.date()).hour(event.target.value).minutes(0);
    this.props.onChange(newDateTime);
  };

  date = () => this.props.datetime;

  time = () => this.props.datetime.get('hour');

  render() {
    const { errors, name } = this.props;
    const label = this.props.label || capitalize(name);

    return (
      <Fragment>
        <div className={`availability-field ${name}-date`}>
          <Label
            attr={`${name}-datepicker`}
            text={`${label} Date`}
            errors={errors}
          />
          <DatePicker
            id={`${name}-datepicker`}
            selected={moment(this.date()).toDate()}
            onChange={this.handleDate}
            errors={errors}
          />
        </div>
        <div className={`availability-field ${name}-time`}>
          <div className="">
            <Label attr={`${name}-time`} text={`${label} Time`} />
            <select
              id={`${name}-time`}
              value={this.time()}
              onChange={this.handleTime}
            >
              {HOURS.map((hour, i) => (
                <option value={i + 1} key={i}>
                  {hour}
                </option>
              ))}
            </select>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default DateTimePicker;
